import React from 'react';
import { useConnect } from '@lore/query-connect';
import { DateTime } from 'luxon';
import { EnvelopeIcon } from '@heroicons/react/24/outline';
import IconSection from '../../pages/_new_card_components/IconSection';

export default function Meta(props) {
  const { question } = props;

  const creator = useConnect('user.byId', {
    id: question.data.creatorId
  });

  const project = useConnect('project.byId', {
    id: question.data.projectId
  });

  return (
    <IconSection
      icon={EnvelopeIcon}
      title={project.data.creatorId !== creator.id ?
        `Invited ${DateTime.fromISO(question.data.createdAt).toRelative()} by ${creator.data.firstName} ${creator.data.lastName} (Steward)` :
        `Invited ${DateTime.fromISO(question.data.createdAt).toRelative()}`
      }
    />
  );
};
